export default __webpack_public_path__ + "static/FiraMono-Medium-20ba9a07845a270a3fdbad4348ced0ac.woff";